@if (trial.notice(); as notice) {
  <aside class="trial-notice" [class.trial-notice--expired]="trial.expired()" role="status">
    {{ notice }}
  </aside>
}
